export default function LeakDetection() {
  const features = [
    {
      icon: 'ri-search-eye-line',
      title: 'Advanced Detection',
      description: 'State-of-the-art thermal imaging cameras identify moisture and leaks invisible to the naked eye.'
    },
    {
      icon: 'ri-time-line',
      title: 'Quick Response',
      description: 'Same-day service available for emergency leak detection and immediate temporary repairs.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Detailed Reports',
      description: 'Comprehensive documentation with photos and recommendations for insurance claims.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Guaranteed Work',
      description: 'All leak repairs backed by our workmanship warranty for your peace of mind.'
    }
  ];

  return (
    <section id="leak-detection" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-600 text-xs font-bold uppercase tracking-wider mb-4">
              LEAK DETECTION
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Find Leaks Before They Become Disasters
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Water damage from roof leaks can cost thousands in repairs. Our advanced leak detection technology identifies problems early, saving you money and protecting your property from extensive damage.
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${feature.icon} text-blue-600 text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-gray-900 mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <a
              href="#contact"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white text-base font-semibold rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Schedule Leak Detection
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </a>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/86b1b819168a4193d2e1ecf71e053556.jpg"
                alt="Leak Detection Technology"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-2xl p-6 max-w-xs">
              <div className="flex items-center mb-3">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-double-line text-orange-600 text-xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">500+</div>
                  <div className="text-sm text-gray-600">Leaks Detected</div>
                </div>
              </div>
              <p className="text-xs text-gray-500">
                Preventing major water damage for Florida homeowners
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}